import { ReportDescription, ReportType } from 'src/app/reports/interfaces/report.interface';

export const reportDescription: { [key: string]: ReportDescription } = {
	[ReportType.StatusReport]: {
		title: null,
		name: `Report.Status.description`,
		contents: [
			{
				title: `Report.Status.content['Active / Inactive'].title`,
				description: `Report.Status.content['Active / Inactive'].description`
			},
			{
				title: `Report.Status.content['Workflow Step'].title`,
				description: `Report.Status.content['Workflow Step'].description`
			},
			{
				title: `Report.Status.content['Workflow Step Status'].title`,
				description: `Report.Status.content['Workflow Step Status'].description`
			}
		]
	},
	[ReportType.GoalsReport]: {
		title: null,
		name: `Report.GoalsReport.description`,
		contents: [
			{
				description: `Report.GoalsReport.content['1'].description`
			},
			{
				description: `Report.GoalsReport.content['2'].description`
			}
		]
	},
	[ReportType.TwoPlusTwoCoachingReport]: {
		title: null,
		name: `Report.TwoPlusTwoCoaching.description`,
		contents: [
			{
				description: `Report.TwoPlusTwoCoaching.content['1'].description`
			}
		]
	},
	[ReportType.FreeEvaluationMidYearReport]: {
		title: null,
		name: `Report.FreeEvaluationMidYear.description`,
	},
	[ReportType.FreeEvaluationEndYearReport]: {
		title: null,
		name: `Report.FreeEvaluationEndYear.description`,
		contents: [
			{
				title: `Report.FreeEvaluationEndYear.content['Had Interaction'].title`,
				description: `Report.FreeEvaluationEndYear.content['Had Interaction'].description`
			},
			{
				title: `Report.FreeEvaluationEndYear.content['I’am Concient'].title"`,
				description: `Report.FreeEvaluationEndYear.content['I’am Concient'].description`
			},
			{
				title: `Report.FreeEvaluationEndYear.content['Comments'].title`,
				description: `Report.FreeEvaluationEndYear.content['Comments'].description`
			},
			{
				title: `Report.FreeEvaluationEndYear.content['Competencies'].title`,
				description: `Report.FreeEvaluationEndYear.content['Competencies'].description`
			},
			{
				title: `Report.FreeEvaluationEndYear.content['Final Concept'].title`,
				description: `Report.FreeEvaluationEndYear.content['Final Concept'].description`
			}
		]
	},
	[ReportType.ThreeSixtyEvaluatorsSelectionReport]: {
		title: null,
		name: `Report.ThreeSixtyEvaluatorsSelectionReport.description`,
		contents: [
			{
				title: `Report.ThreeSixtyEvaluatorsSelectionReport.content['Status'].title`,
				description: `Report.ThreeSixtyEvaluatorsSelectionReport.content['Status'].description`
			},
			{
				title: `Report.ThreeSixtyEvaluatorsSelectionReport.content['Evaluation Status'].title`,
				description: `Report.ThreeSixtyEvaluatorsSelectionReport.content['Evaluation Status'].description`
			}
		]
	},
	[ReportType.ThreeSixtyEvaluationReport]: {
		title: null,
		name: `Report.ThreeSixtyEvaluationReport.description`,
	},
	[ReportType.ThreeSixtyEvaluationManagerReport]: {
		title: null,
		name: `Report.ThreeSixtyEvaluationManagerReport.description`
	},
	[ReportType.SelfManagerReport]: {
		title: null,
		name: `Report.FinalEvaluationReport.description`,
		contents: [
			{
				description: `Report.FinalEvaluationReport.content['1'].description`
			},
			{
				description: `Report.FinalEvaluationReport.content['2'].description`
			}
		]
	},
	[ReportType.ExecutiveReport]: {
		title: null,
		name: `Report.ExecutiveReport.description`,
		contents: [
			{
				title: `Report.ExecutiveReport.content['Type'].title`,
				description: `Report.ExecutiveReport.content['Type'].description`
			},
			{
				title: `Report.ExecutiveReport.content['"Principal Final Grades" e "Goals Grade"'].title`,
				description: `Report.ExecutiveReport.content['"Principal Final Grades" e "Goals Grade"'].description`
			},
			{
				title: `Report.ExecutiveReport.content['Colunas "Culture and Principles" e "Performance'].title`,
				description: `Report.ExecutiveReport.content['Colunas "Culture and Principles" e "Performance'].description`
			},
			{
				title: `Report.ExecutiveReport.content['"Final Concept" e "Comments"'].title`,
				description: `Report.ExecutiveReport.content['"Final Concept" e "Comments"'].description`
			}
		]
	},
	[ReportType.ExecutiveReportWithEvaluator]: {
		title: null,
		name: `Report.ExecutiveReportWithEvaluator.description`,
		contents: [
			{
				title: `Report.ExecutiveReportWithEvaluator.content['Type'].title`,
				description: `Report.ExecutiveReportWithEvaluator.content['Type'].description`
			},
			{
				title: `Report.ExecutiveReportWithEvaluator.content['"Principal Final Grades" e "Goals Grade"'].title`,
				description: `Report.ExecutiveReportWithEvaluator.content['"Principal Final Grades" e "Goals Grade"'].description`
			},
			{
				title: `Report.ExecutiveReportWithEvaluator.content['Colunas "Culture and Principles" e "Performance'].title`,
				description: `Report.ExecutiveReportWithEvaluator.content['Colunas "Culture and Principles" e "Performance'].description`
			},
			{
				title: `Report.ExecutiveReportWithEvaluator.content['"Final Concept" e "Comments"'].title`,
				description: `Report.ExecutiveReportWithEvaluator.content['"Final Concept" e "Comments"'].description`
			}
		]
	},
	[ReportType.HistoricExecutiveReportWithEvaluator]: {
		title: null,
		name: `Report.HistoricExecutiveReportWithEvaluator.description`,
		contents: [
			{
				title: `Report.HistoricExecutiveReportWithEvaluator.content['Type'].title`,
				description: `Report.HistoricExecutiveReportWithEvaluator.content['Type'].description`
			},
			{
				title: `Report.HistoricExecutiveReportWithEvaluator.content['"Principal Final Grades" e "Goals Grade"'].title`,
				description: `Report.HistoricExecutiveReportWithEvaluator.content['"Principal Final Grades" e "Goals Grade"'].description`
			},
			{
				title: `Report.HistoricExecutiveReportWithEvaluator.content['Colunas "Culture and Principles" e "Performance'].title`,
				description: `Report.HistoricExecutiveReportWithEvaluator.content['Colunas "Culture and Principles" e "Performance'].description`
			},
			{
				title: `Report.HistoricExecutiveReportWithEvaluator.content['"Final Concept" e "Comments"'].title`,
				description: `Report.HistoricExecutiveReportWithEvaluator.content['"Final Concept" e "Comments"'].description`
			}
		]
	},
	[ReportType.DiversityCheck]: {
		title: null,
		name: `Report.DiversityCheckReport.description`,
	},
	[ReportType.Feedback]: {
		title: null,
		name: `Report.Feedback.description`,
	},
    [ReportType.AllUsersReport]: {
        title: null,
        name: `Report.AllUsersReport.description`,
    }
};
